<template>
  <div v-if="productData" class="advCartRow">
    <div v-if="miniCart">
      <div class="text-center cart_list_item border-bottom pb-2 minicartItem mr-3">
        <div class="row p-2">
          <div class="col-2 cart_list_item_thumbnail pr-0">
            <img class="img-fluid" :src="imageSrc" :alt="productData.productName"/>
          </div>
          <div class="col-9 text-sm text-dark font-weight-bold text-left cart_list_item_name pr-0">
            {{ productData.productName }}
          </div>
          <div class="col-1 pl-0">
            <a href="#" v-on:click="removeProductFromCart" :disabled="!onlineStatus" class="action-item pt-0" v-if="!readOnly">
              <i class="fas fa-times"></i>
            </a>
          </div>
         <!--  <div class="col-2"></div> -->
          <div class="col-5 text-left my-auto mini-cart-price-col">
            <span class="text-sm pr-3 h6">
                {{ t('price') }}: <span v-html="finalTotalPriceWithSign"></span>
            </span>
          </div>
          <div class="col-7 miniCartSpinner" v-if="!readOnly">
            <adv-product-input-spinner
                    class="quantitySpinner"
                    :product-code-id="cartProduct.productCodeId"
                    :quantity="cartProduct.quantity"
                    v-on:quantity-changed="updateProductQuantity">
            </adv-product-input-spinner>
          </div>
          <div class="col-12" v-if="readOnly">
            <span class="text-sm pr-3 h6">
              Ποσότητα: {{ cartProduct.quantity }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!miniCart">
    <div class="row text-center cart_list_item m-2 p-2 rounded border">
      <div class="col-12 px-3 pb-3 mt-0 mb-3 border-bottom col-sm-1 border-sm-bottom-0 border-sm-right mb-sm-0 p-sm-0 cart_list_item_thumbnail">
        <img class="img-fluid"  :src="imageSrc" :alt="productData.productName">
      </div>
      <div class="col-12 col-sm-11 col-md-5 text-left">
          <a :href="productData.productUrl" class="cart_list_item_name">
            {{ productData.productName }}
          </a>
        <div class="h6 mt-3"><small>{{ t('price') }} / {{ t('package') }}:</small>
          <b><span v-html="finalPriceWithSign"></span></b>
        </div>
      </div>
      <div class="col-6 col-md-2 minicartItem" v-if="!readOnly">
        <adv-product-input-spinner
                class="quantitySpinner"
                :product-code-id="cartProduct.productCodeId"
                :quantity="cartProduct.quantity"
                v-on:quantity-changed="updateProductQuantity">
        </adv-product-input-spinner>
      </div>
      <div class="col-xs-12 col-sm-3 col-md-3 advSpinnerRow" v-if="readOnly">
        {{ cartProduct.quantity }}
      </div>
      <div class="col-xs-12 col-sm-4 col-md-3 pull-right advCartRowTotal">
        <div v-show="productData.productHasDiscount" class="d-none">
          <small class="advCartDiscTtl">{{ t('discount') }}</small>
          <span class="advCartDiscPerc text-primary">
            <b>{{ productData.productDisclosure }}</b>
          </span>
        </div>
        <s v-show="productData.productHasDiscount" class="advCartPrevPrice d-none" v-html="originalTotalPriceWithSign"></s>
        <b class="advCartFinalPrice" v-html="finalTotalPriceWithSign"></b>
      </div>
      <a href="#" v-on:click="removeProductFromCart"  v-if="!readOnly" :disabled="!onlineStatus" class="action-item pt-0">
        <i class="fas fa-times"></i>
      </a>
    </div>
      <div v-show="productCodeData.productCodeAttributes.length > 0" class="col-xs-12 advCartRowAttr">
          <span>
            {{ productCodeAttributes }}
          </span>
      </div>
      <div class="col-xs-12 text-center helpCartMsg" v-show="cartError && !readOnly">
        <i class="ti-info-alt"></i> {{ cartError }}
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import onlineMixin from './mixins/onlineMixin'
import AdvProductInputSpinner from './AdvProductInputSpinner'

export default {
  name: 'AdvCartProductRow',
  components: {
    AdvProductInputSpinner
  },
  mixins: [onlineMixin],
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    cartError () {
      return store.getters.cartProductErrorMsg(this.cartProduct.productCodeId)
    },
    productCodeData () {
      return store.getters.getSelectedProductCodeByCodeId(this.cartProduct.productCodeId)
    },
    originalTotalPriceWithSign () {
      const price = this.productData.productOldPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalPriceWithSign () {
      return (this.productData.productFinalPrice * store.getters.getSelectedCurrency.rate).toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalTotalPriceWithSign () {
      const price = this.productData.productFinalPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    productData () {
      return store.getters.getProductById(this.cartProduct.productId)
    },
    imageSrc () {
      return this.productData.hasOwnProperty('images') ? this.productData.images[this.cartProduct.productCodeId].find(item => item.is_main === '1')['small'] : store.getters.noImage
    },
    productCodeAttributes () {
      return this.productCodeData.productCodeAttributes.reduce((acc, item) => {
        if (acc !== '') {
          acc += ' - '
        }

        acc += store.getters.attributeName(item)
        return acc
      }, '')
    }
  },
  methods: {
    removeProductFromCart () {
      store.dispatch('addToCartClicked', { productCodeId: this.cartProduct.productCodeId, quantity: 0 })
    },
    updateProductQuantity (quantity) {
      store.dispatch('addToCartClicked', { productCodeId: this.cartProduct.productCodeId, quantity: quantity })
    }
  }
}
</script>
